function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import History from "./history";
import Settings from "./settings";
import Url from "./url";
import Http from "./http";
import Type from "./type";
import App from "./app";
import Dom from "./dom";
import Launch from "./launch";
import Format from "./format";
import Ws from "./private/ws";

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "history",
    get: function get() {
      return History;
    }
  }, {
    key: "settings",
    get: function get() {
      return Settings;
    }
  }, {
    key: "url",
    get: function get() {
      return Url;
    }
  }, {
    key: "http",
    get: function get() {
      return Http;
    }
  }, {
    key: "type",
    get: function get() {
      return Type;
    }
  }, {
    key: "app",
    get: function get() {
      return App;
    }
  }, {
    key: "dom",
    get: function get() {
      return Dom;
    }
  }, {
    key: "format",
    get: function get() {
      return Format;
    }
  }, {
    key: "ws",
    get: function get() {
      return Ws;
    } // Move this to Glib/public ?

  }, {
    key: "launch",
    get: function get() {
      return Launch;
    }
  }]);

  return _default;
}();

export { _default as default };